export const environment = {
  production: false,
  backendApi: 'https://roadaware-dev.neotreks.com/',
  issuer: 'https://roadaware-dev.neotreks.com',
  requireHttps: true,
  postLogoutRedirectUri: 'https://roadaware-dev.neotreks.com/account/signin',
  resetPasswordTemplateUrl: 'https://roadaware-dev.neotreks.com/account/reset-password?token={0}&user={1}',
};
